// import React from 'react';

// const CalendarIcon = () => (
//   <svg style={{ width: '16px', height: '16px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//     <line x1="16" y1="2" x2="16" y2="6"></line>
//     <line x1="8" y1="2" x2="8" y2="6"></line>
//     <line x1="3" y1="10" x2="21" y2="10"></line>
//   </svg>
// );

// const DownloadIcon = () => (
//   <svg style={{ width: '16px', height: '16px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//     <polyline points="7 10 12 15 17 10"></polyline>
//     <line x1="12" y1="15" x2="12" y2="3"></line>
//   </svg>
// );

// export default function ModernReportForm({
//   timePeriod,
//   setTimePeriod,
//   startDate,
//   setStartDate,
//   endDate,
//   setEndDate,
//   progress,
//   onDownload,
//   disabled = false,
//   allowedPeriods = ["today", "custom", "custom-week", "custom-month"],
// }) {
//   const [showDatePicker, setShowDatePicker] = React.useState(false);
//   const [showWeekPicker, setShowWeekPicker] = React.useState(false);
//   const [showMonthPicker, setShowMonthPicker] = React.useState(false);

//   const formatDate = (date) =>
//     `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
//       date.getDate()
//     ).padStart(2, '0')}`;

//   const formatYearMonth = (date) =>
//     `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

//   const today = new Date();
//   const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
//   const nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

//   const effectiveMinDate = formatDate(prevMonth);
//   const effectiveMaxDate = formatDate(nextMonthEnd);

//   const handleTimePeriodChange = (value) => {
//     setTimePeriod(value);
//     setShowDatePicker(false);
//     setShowWeekPicker(false);
//     setShowMonthPicker(false);

//     if (value === 'today') {
//       const todayStr = formatDate(new Date());
//       setStartDate(todayStr);
//       setEndDate(todayStr);
//     } else if (value === 'custom') {
//       setStartDate("");
//       setEndDate("");
//       setShowDatePicker(true);
//     } else if (value === 'custom-week') {
//       setStartDate("");
//       setEndDate("");
//       setShowWeekPicker(true);
//     } else if (value === 'custom-month') {
//       setStartDate("");
//       setEndDate("");
//       setShowMonthPicker(true);
//     }
//   };

//   const periods = [
//     { value: 'today', label: 'Today', icon: '📅' },
//     { value: 'custom', label: 'Date', icon: '📆' },
//     { value: 'custom-week', label: 'Week', icon: '📊' },
//     { value: 'custom-month', label: 'Month', icon: '📈' },
//   ].filter((p) => allowedPeriods.includes(p.value));

//   return (
//     <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '0.5rem 0' }}>
//       <style>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div
//         style={{
//           borderRadius: '10px',
//           padding: '0.75rem 1rem',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           gap: '0.75rem',
//           maxWidth: 'fit-content',
//         }}
//       >
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', alignItems: 'center' }}>
//           <div style={{ display: 'flex', gap: '0.4rem' }}>
//             {periods
//               .filter((p) => p.value === 'today' || p.value === 'custom')
//               .map((option) => (
//                 <button
//                   key={option.value}
//                   onClick={() => handleTimePeriodChange(option.value)}
//                   style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     gap: '0.1rem',
//                     padding: '0.35rem 0.5rem',
//                     border: `2px solid ${timePeriod === option.value ? '#3b82f6' : '#e5e7eb'}`,
//                     background:
//                       timePeriod === option.value
//                         ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
//                         : 'white',
//                     color: timePeriod === option.value ? 'white' : '#6b7280',
//                     borderRadius: '8px',
//                     cursor: 'pointer',
//                     transition: 'all 0.2s',
//                     minWidth: '55px',
//                   }}
//                 >
//                   <span style={{ fontSize: '1.1rem' }}>{option.icon}</span>
//                   <span style={{ fontSize: '0.65rem', fontWeight: 600 }}>{option.label}</span>
//                 </button>
//               ))}
//           </div>

//           <div style={{ display: 'flex', gap: '0.4rem' }}>
//             {periods
//               .filter((p) => p.value === 'custom-week' || p.value === 'custom-month')
//               .map((option) => (
//                 <button
//                   key={option.value}
//                   onClick={() => handleTimePeriodChange(option.value)}
//                   style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     gap: '0.1rem',
//                     padding: '0.35rem 0.5rem',
//                     border: `2px solid ${timePeriod === option.value ? '#3b82f6' : '#e5e7eb'}`,
//                     background:
//                       timePeriod === option.value
//                         ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
//                         : 'white',
//                     color: timePeriod === option.value ? 'white' : '#6b7280',
//                     borderRadius: '8px',
//                     cursor: 'pointer',
//                     transition: 'all 0.2s',
//                     minWidth: '55px',
//                   }}
//                 >
//                   <span style={{ fontSize: '1.1rem' }}>{option.icon}</span>
//                   <span style={{ fontSize: '0.65rem', fontWeight: 600 }}>{option.label}</span>
//                 </button>
//               ))}
//           </div>
//         </div>

//         {(showDatePicker || showWeekPicker || showMonthPicker) && (
//           <div style={{ width: '180px', minWidth: '180px' }}>
//             <input
//               key={timePeriod}
//               type={showMonthPicker ? 'month' : 'date'}
//               min={showMonthPicker ? effectiveMinDate.slice(0, 7) : effectiveMinDate}
//               max={showMonthPicker ? effectiveMaxDate.slice(0, 7) : effectiveMaxDate}
//               value={
//                 showMonthPicker
//                   ? startDate?.slice(0, 7) || ""
//                   : startDate || ""
//               }
//               style={{
//                 width: '100%',
//                 padding: '0.5rem 0.65rem',
//                 border: '2px solid #93c5fd',
//                 borderRadius: '8px',
//                 fontSize: '0.8rem',
//                 outline: 'none',
//                 background: '#eff6ff',
//                 fontWeight: 500,
//               }}
//               onChange={(e) => {
//                 if (showDatePicker) {
//                   setStartDate(e.target.value);
//                   setEndDate(e.target.value);
//                 } else if (showWeekPicker) {
//                   const start = new Date(e.target.value);
//                   const end = new Date(start);
//                   end.setDate(start.getDate() + 6);
//                   setStartDate(formatDate(start));
//                   setEndDate(formatDate(end));
//                 } else if (showMonthPicker) {
//                   const [year, month] = e.target.value.split('-');
//                   const start = new Date(year, month - 1, 1);
//                   const end = new Date(year, month, 0);
//                   setStartDate(formatDate(start));
//                   setEndDate(formatDate(end));
//                 }
//               }}
//             />
//           </div>
//         )}

//         <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
//           <button
//             onClick={onDownload}
//             disabled={disabled || progress > 0}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '0.35rem',
//               padding: '0.5rem 0.85rem',
//               background:
//                 disabled || progress > 0
//                   ? '#9ca3af'
//                   : 'linear-gradient(135deg, #3b82f6, #2563eb)',
//               color: 'white',
//               border: 'none',
//               borderRadius: '8px',
//               fontSize: '0.8rem',
//               fontWeight: 600,
//               cursor: disabled || progress > 0 ? 'not-allowed' : 'pointer',
//               transition: 'all 0.3s',
//             }}
//           >
//             {progress > 0 ? (
//               <>
//                 <div
//                   style={{
//                     width: '14px',
//                     height: '14px',
//                     border: '2px solid white',
//                     borderTopColor: 'transparent',
//                     borderRadius: '50%',
//                     animation: 'spin 0.8s linear infinite',
//                   }}
//                 />
//                 <span>{progress}%</span>
//               </>
//             ) : (
//               <>
//                 <DownloadIcon />
//                 <span>Download</span>
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }




// import React from 'react';

// const CalendarIcon = () => (
//   <svg style={{ width: '16px', height: '16px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//     <line x1="16" y1="2" x2="16" y2="6"></line>
//     <line x1="8" y1="2" x2="8" y2="6"></line>
//     <line x1="3" y1="10" x2="21" y2="10"></line>
//   </svg>
// );

// const DownloadIcon = () => (
//   <svg style={{ width: '16px', height: '16px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//     <polyline points="7 10 12 15 17 10"></polyline>
//     <line x1="12" y1="15" x2="12" y2="3"></line>
//   </svg>
// );

// export default function ModernReportForm({
//   timePeriod,
//   setTimePeriod,
//   startDate,
//   setStartDate,
//   endDate,
//   setEndDate,
//   progress,
//   onDownload,
//   disabled = false,
//   allowedPeriods = ["today", "custom", "custom-week", "custom-month"],
// }) {
//   const [showDatePicker, setShowDatePicker] = React.useState(false);
//   const [showWeekPicker, setShowWeekPicker] = React.useState(false);
//   const [showMonthPicker, setShowMonthPicker] = React.useState(false);

//   const formatDate = (date) =>
//     `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
//       date.getDate()
//     ).padStart(2, '0')}`;

//   // const today = new Date();
//   // const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
//   // const nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

//   // const effectiveMinDate = formatDate(prevMonth);
//   // const effectiveMaxDate = formatDate(nextMonthEnd);

// const today = new Date();
//   const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);
//     // const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1);
//   const nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
//   const effectiveMinDate = formatDate(twoMonthsAgo);
//   const effectiveMaxDate = formatDate(nextMonthEnd);

//   const handleTimePeriodChange = (value) => {
//     setTimePeriod(value);
//     setShowDatePicker(false);
//     setShowWeekPicker(false);
//     setShowMonthPicker(false);

//     if (value === 'today') {
//       const todayStr = formatDate(new Date());
//       setStartDate(todayStr);
//       setEndDate(todayStr);
//     } else if (value === 'custom') {
//       setStartDate("");
//       setEndDate("");
//       setShowDatePicker(true);
//     } else if (value === 'custom-week') {
//       setStartDate("");
//       setEndDate("");
//       setShowWeekPicker(true);
//     } else if (value === 'custom-month') {
//       setStartDate("");
//       setEndDate("");
//       setShowMonthPicker(true);
//     }
//   };

//   const periods = [
//     { value: 'today', label: 'Today', icon: '📅' },
//     { value: 'custom', label: 'Date', icon: '📆' },
//     { value: 'custom-week', label: 'Week', icon: '📊' },
//     { value: 'custom-month', label: 'Month', icon: '📈' },
//   ].filter((p) => allowedPeriods.includes(p.value));

//   return (
//     <div style={{ width: '100%', display: 'flex', justifyContent: 'center',}}>
//       <style>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div
//         style={{
//           borderRadius: '10px',
//           padding: '0.2rem 0.2rem',
//           display: 'flex',
//           flexDirection: 'row',
//           alignItems: 'center',
//           gap: '0.2rem',
//           flexWrap: 'wrap',
//           maxWidth: '95%',
//           justifyContent: 'center'
//         }}
//       >

//         {periods.map((option) => (
//           <button
//             key={option.value}
//             onClick={() => handleTimePeriodChange(option.value)}
//             style={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               gap: '0.1rem',
//               padding: '0.35rem 0.6rem',
//               border: `2px solid ${timePeriod === option.value ? '#3b82f6' : '#e5e7eb'}`,
//               background:
//                 timePeriod === option.value
//                   ? 'linear-gradient(135deg, #3b82f6, #2563eb)'
//                   : 'white',
//               color: timePeriod === option.value ? 'white' : '#6b7280',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               transition: 'all 0.2s',
//               minWidth: '55px',
//             }}
//           >
//             <span style={{ fontSize: '1.1rem' }}>{option.icon}</span>
//             <span style={{ fontSize: '0.65rem', fontWeight: 600 }}>{option.label}</span>
//           </button>
//         ))}

//         {(showDatePicker || showWeekPicker || showMonthPicker) && (
//           <input
//             key={timePeriod}
//             type={showMonthPicker ? 'month' : 'date'}
//             min={showMonthPicker ? effectiveMinDate.slice(0, 7) : effectiveMinDate}
//             max={showMonthPicker ? effectiveMaxDate.slice(0, 7) : effectiveMaxDate}
//             value={showMonthPicker ? startDate?.slice(0, 7) || "" : startDate || ""}
//             style={{
//               width: '150px',
//               padding: '0.45rem 0.5rem',
//               border: '2px solid #93c5fd',
//               borderRadius: '8px',
//               fontSize: '0.8rem',
//               background: '#eff6ff',
//               outline: 'none',
//               fontWeight: 500,
//             }}
//             onChange={(e) => {
//               if (showDatePicker) {
//                 setStartDate(e.target.value);
//                 setEndDate(e.target.value);
//               } else if (showWeekPicker) {
//                 const s = new Date(e.target.value);
//                 const e2 = new Date(s);
//                 e2.setDate(s.getDate() + 6);
//                 setStartDate(formatDate(s));
//                 setEndDate(formatDate(e2));
//               } else if (showMonthPicker) {
//                 const [y, m] = e.target.value.split("-");
//                 const s = new Date(y, m - 1, 1);
//                 const e2 = new Date(y, m, 0);
//                 setStartDate(formatDate(s));
//                 setEndDate(formatDate(e2));
//               }
//             }}
//           />
//         )}

//         <button
//           onClick={onDownload}
//           disabled={disabled || progress > 0}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.35rem',
//             padding: '0.5rem 0.85rem',
//             background:
//               disabled || progress > 0
//                 ? '#9ca3af'
//                 : 'linear-gradient(135deg, #3b82f6, #2563eb)',
//             color: 'white',
//             border: 'none',
//             borderRadius: '8px',
//             fontSize: '0.8rem',
//             fontWeight: 600,
//             cursor: disabled || progress > 0 ? 'not-allowed' : 'pointer',
//             transition: 'all 0.3s',
//           }}
//         >
//           {progress > 0 ? (
//             <>
//               <div
//                 style={{
//                   width: '14px',
//                   height: '14px',
//                   border: '2px solid white',
//                   borderTopColor: 'transparent',
//                   borderRadius: '50%',
//                   animation: 'spin 0.8s linear infinite',
//                 }}
//               />
//               <span>{progress}%</span>
//             </>
//           ) : (
//             <>
//               <DownloadIcon />
//               <span>Download</span>
//             </>
//           )}
//         </button>
//       </div>
//     </div>
//   );
// }

import React from "react";

const CalendarIcon = () => (
  <svg
    style={{ width: "16px", height: "16px" }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const DownloadIcon = () => (
  <svg
    style={{ width: "16px", height: "16px" }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

export default function ModernReportForm({
  timePeriod,
  setTimePeriod,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  progress,
  onDownload,
  disabled = false,
  allowedPeriods = ["today", "custom", "custom-week", "custom-month"],
}) {
  const [showDatePicker, setShowDatePicker] = React.useState(false);
  const [showWeekPicker, setShowWeekPicker] = React.useState(false);
  const [showMonthPicker, setShowMonthPicker] = React.useState(false);

  const formatDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;

  const today = new Date();

  const currentMonthStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );

  const sixMonthsAgo = new Date(
    today.getFullYear(),
    today.getMonth() - 2,
    1
  );

  const formatMonth = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

  const minMonth = formatMonth(sixMonthsAgo);
  const maxMonth = formatMonth(currentMonthStart);

  const effectiveMinDate = formatDate(sixMonthsAgo);
  const effectiveMaxDate = formatDate(
    new Date(today.getFullYear(), today.getMonth() + 1, 0)
  );

  const handleTimePeriodChange = (value) => {
    setTimePeriod(value);
    setShowDatePicker(false);
    setShowWeekPicker(false);
    setShowMonthPicker(false);

    if (value === "today") {
      const todayStr = formatDate(new Date());
      setStartDate(todayStr);
      setEndDate(todayStr);
    } else if (value === "custom") {
      setStartDate("");
      setEndDate("");
      setShowDatePicker(true);
    } else if (value === "custom-week") {
      setStartDate("");
      setEndDate("");
      setShowWeekPicker(true);
    } else if (value === "custom-month") {
      setStartDate("");
      setEndDate("");
      setShowMonthPicker(true);
    }
  };

  const periods = [
    { value: "today", label: "Today", icon: "📅" },
    { value: "custom", label: "Date", icon: "📆" },
    { value: "custom-week", label: "Week", icon: "📊" },
    { value: "custom-month", label: "Month", icon: "📈" },
  ].filter((p) => allowedPeriods.includes(p.value));

  const lastSixMonths = [];
  for (let i = 0; i < 3; i++) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    lastSixMonths.push({
      value: formatMonth(d),
      label: d.toLocaleString("default", { month: "short", year: "numeric" }),
    });
  }

const isMobile = window.innerWidth <= 768;

return (
  <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

    <div style={{
      borderRadius: "10px",
      padding: "0.2rem",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",  /* ← key change */
      gap: "0.3rem",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box",
      justifyContent: "center",
    }}>

      {/* Period buttons row */}
      <div style={{
        display: "flex",
        flexWrap: "nowrap",
        gap: "0.2rem",
        justifyContent: "center",
        alignItems: "center",
      }}>
        {periods.map((option) => (
          <button
            key={option.value}
            onClick={() => handleTimePeriodChange(option.value)}
            style={{
              padding: "0.35rem 0.6rem",
              border: timePeriod === option.value ? "2px solid #3b82f6" : "2px solid #e5e7eb",
              background: timePeriod === option.value ? "linear-gradient(135deg, #3b82f6, #2563eb)" : "white",
              color: timePeriod === option.value ? "white" : "#6b7280",
              borderRadius: "8px",
              cursor: "pointer",
              minWidth: "55px",
              flexShrink: 0,
            }}
          >
            <div style={{ fontSize: "1.1rem" }}>{option.icon}</div>
            <div style={{ fontSize: "0.65rem", fontWeight: 600 }}>{option.label}</div>
          </button>
        ))}
      </div>

      {/* Picker + Download row */}
      <div style={{
        display: "flex",
        flexWrap: "nowrap",
        gap: "0.2rem",
        justifyContent: "center",
        alignItems: "center",
      }}>
        {(showDatePicker || showWeekPicker) && (
          <input
            key={timePeriod}
            type="date"
            min={effectiveMinDate}
            max={effectiveMaxDate}
            value={startDate || ""}
            style={{
              flex: "1",
              minWidth: "90px",
              maxWidth: "120px",
              padding: "0.3rem",
              border: "2px solid #93c5fd",
              borderRadius: "8px",
              fontSize: "0.7rem",
              background: "#eff6ff",
              boxSizing: "border-box",
            }}
            onChange={(e) => {
              if (showDatePicker) {
                setStartDate(e.target.value);
                setEndDate(e.target.value);
              } else if (showWeekPicker) {
                const s = new Date(e.target.value);
                const minAllowed = new Date(effectiveMinDate);
                const clampedS = s < minAllowed ? minAllowed : s;
                const e2 = new Date(clampedS);
                e2.setDate(clampedS.getDate() + 6);
                setStartDate(formatDate(clampedS));
                setEndDate(formatDate(e2));
              }
            }}
          />
        )}

        {showMonthPicker && (
          <select
            value={startDate?.slice(0, 7) || ""}
            style={{
              flex: "1",
              minWidth: "90px",
              maxWidth: "120px",
              padding: "0.3rem",
              border: "2px solid #93c5fd",
              borderRadius: "8px",
              fontSize: "0.7rem",
              background: "#eff6ff",
              boxSizing: "border-box",
            }}
            onChange={(e) => {
              const selectedMonth = e.target.value;
              const [y, m] = selectedMonth.split("-");
              const start = new Date(y, m - 1, 1);
              const end = new Date(y, m, 0);
              setStartDate(formatDate(start));
              setEndDate(formatDate(end));
            }}
          >
            <option value="">Month</option>
            {lastSixMonths.map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
        )}

        <button
          onClick={onDownload}
          disabled={disabled || progress > 0}
          style={{
            width: "36px",
            height: "36px",
            padding: "0",
            background: disabled || progress > 0 ? "#9ca3af" : "linear-gradient(135deg, #3b82f6, #2563eb)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "0.75rem",
            fontWeight: 600,
            cursor: disabled || progress > 0 ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {progress > 0 ? `${progress}%` : <DownloadIcon />}
        </button>
      </div>

    </div>
  </div>
);
}
